import React, {Fragment} from "react";

export default function ({data}) {

  return (
    <div className="col-12 pt-5">
      <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="card-title">
            <h2>Products</h2>
          </div>

        </div>
        <div className="card-body pt-0">
          <div className="table-responsive">
            <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
              <thead>
              <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0 border-bottom-2 border-dark">
                <th className="min-w-175px">Id</th>
                <th className="min-w-175px">Name</th>
                <th className="min-w-175px">Shop Name</th>
                <th className="min-w-100px">SKU</th>
                <th className="min-w-70px">Qty</th>
                <th className="min-w-70px">Status</th>
                <th className="min-w-100px">Unit Price</th>
                <th className="min-w-150px">Dealing Price</th>
                <th className="min-w-100px">Total</th>
                {/*<th className="min-w-100px">Action</th>*/}
              </tr>
              </thead>
              <tbody className="fw-bold text-gray-600">
              {data?.order?.products?.map((product, index) => {
                return <Fragment key={index}>
                  <tr>
                    <td>
                      {product.id}
                    </td>
                    <td>
                      {/*<div className="d-flex align-items-center">*/}
                      {/*  {product.image && <span*/}
                      {/*    className="symbol-label"*/}
                      {/*    style={{*/}
                      {/*      backgroundImage:*/}
                      {/*        `url(${product.image})`*/}
                      {/*    }}*/}
                      {/*  />}*/}
                      {/*  <div className="ms-5">*/}
                      {/*    {product.name}*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                      {product.name}
                    </td>
                    <td>{product.shop_name}</td>
                    <td >{product.sku}</td>
                    <td >{product.quantity}</td>
                    <td >
                      {data?.orderProductStatuses?.find(item => item.id === product.status)?.name}
                    </td>
                    <td >{product.product_price}</td>
                    <td >{product.dealing_price}</td>
                    <td>{product.total_price}</td>
                  </tr>
                  {product.addresses.length && (
                    <tr className="border-bottom-2 border-dark">
                      <td colSpan={3}>
                        {product.addresses.map((address, key) => {
                          return <div key={key} className="row pt-4 pb-4">
                            <div className="col">Address</div>
                            <div className="col">Quantity</div>
                            <div className="col">Delivery Code</div>
                            <div className="w-100"></div>
                            <div className="col fw-normal mt-2">{address.shop_address}</div>
                            <div className="col fw-normal mt-2">{address.quantity}</div>
                            <div className="col fw-normal mt-2">{address.delivery_code}</div>
                          </div>
                        })}
                      </td>
                    </tr>
                  )}
                </Fragment>
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}